// import * as React from 'react';
// import Stack from '@mui/material/Stack';
// import Snackbar from '@mui/material/Snackbar';
// import MuiAlert from '@mui/material/Alert';

// const Alert = React.forwardRef(function Alert(props, ref) {
//   return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
// });

// export function SuccessAlert({ isOpen, message, anchorOrigin, autoHideDuration, vertical = "top"  }) {

//   const [open, setOpen] = React.useState(isOpen);

//   const handleClose = (event, reason) => {
//     if (reason === 'clickaway') {
//       return;
//     }

//     setOpen(false);
//   };

//   return (
//     <Stack spacing={2} sx={{ width: '100%' }}>

//       <Snackbar
//         autoHideDuration={autoHideDuration ?? 5000}
//         open={open}
//         onClose={handleClose}
//         anchorOrigin={anchorOrigin ?? { vertical: vertical, horizontal: 'center' }}>
//         <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
//           {message}
//         </Alert>
//       </Snackbar>

//     </Stack>
//   );
// }

import * as React from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return (
    <MuiAlert
      elevation={6}
      ref={ref}
      variant="filled"
      severity="success"
      {...props}
      sx={{
        backgroundColor: "#198754",
        borderBottomColor: "white",
        color: "#FAFAFA",
        display: "flex",
        alignItems: "center",
        fontFamily: "GT Walsheim Pro",
        borderBottomWidth: "4px",
        borderRadius: "8px",
        zIndex: 9999,
        "& .MuiAlert-icon": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "8px",
        },
        ...props.sx,
      }}
    />
  );
});

export function SuccessAlert({
  isOpen,
  message,
  anchorOrigin,
  autoHideDuration,
  vertical = "top",
  isDesktop = false,
}) {
  const [open, setOpen] = React.useState(isOpen);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        autoHideDuration={autoHideDuration ?? 5000}
        open={open}
        onClose={handleClose}
        anchorOrigin={
          anchorOrigin ?? {
            vertical: vertical,
            horizontal: isDesktop ? "right" : "center",
          }
        }
      >
        <Alert
          onClose={handleClose}
          sx={{ width: isDesktop ? "370px" : "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
